// App.js
import React from 'react'; 
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ThankYouPage from './pages/ThankYouPage';
import HomePage from './pages/HomePage';
import 'aos/dist/aos.css';
import GetContact from './pages/GetContact';

function App() {
  return (
    <div className="app-bg">
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
          <Route path="/get-contact" element={<GetContact />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
